@use "../../styles/breakpoint.module.scss" as *;

.root {
    padding-block: var(--spacer-104);
    background-color: var(--light-beige);
}

.inner {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.column {
    grid-column-end: span 4;

    &:first-child {
        grid-column-start: 2;
    }

    &:last-child {
        grid-column-start: 8;
    }

    @media ($below-tablet) {
        grid-column-end: span 6;

        &:first-child {
            grid-column-start: 1;
        }

        &:last-child {
            grid-column-start: 7;
        }
    }

    @media ($below-mobile) {
        grid-column-end: -1;

        &:first-child,
        &:last-child {
            grid-column-start: 1;
        }
    }
}

.title {
    font: var(--font-h-34);
    margin-bottom: var(--spacer-16);
}

.text {
    font: var(--font-p-16);
    margin-bottom: var(--spacer-24);
}

.image {
    display: block;
    margin-block: var(--spacer-24);
    width: 100px;
    height: auto;
}

.favoritesList {
    margin-top: var(--spacer-48);
}
